import { createFileRoute } from '@tanstack/react-router'

import { OverviewScreen } from '@/features/platform-overview/overview-screen'

/** Every org's activity and the market's health: the console's landing screen. */
export const Route = createFileRoute('/_app/platform/overview')({
  component: OverviewScreen,
})
